/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_FailedInputs */

const en_player_failed = /** @type {(inputs: Player_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not passed`)
};

const ja_player_failed = /** @type {(inputs: Player_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不合格`)
};

const fr_player_failed = /** @type {(inputs: Player_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non réussi`)
};

const de_player_failed = /** @type {(inputs: Player_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht bestanden`)
};

/**
* | output |
* | --- |
* | "Not passed" |
*
* @param {Player_FailedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_failed = /** @type {((inputs?: Player_FailedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_FailedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_failed(inputs)
	if (locale === "ja") return ja_player_failed(inputs)
	if (locale === "fr") return fr_player_failed(inputs)
	return de_player_failed(inputs)
});